import { TimelineTabs as MatchboxTimelineTabs } from '@sparkpost/matchbox';

/**
 * Matchbox TimelineTabs component
 * @see https://design.sparkpost.com/components/timelinetabs/
 */
const TimelineTabs = MatchboxTimelineTabs;

export default TimelineTabs;
